var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('skill-block',{attrs:{"pilot":_vm.pilot}}),_c('dt-resources-block',{attrs:{"pilot":_vm.pilot}}),_c('pilot-loadout-block',{attrs:{"pilot":_vm.pilot}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }